import React, {useContext, useEffect, useState} from 'react';
import Tabs from "@common/Tabs";
import Tab from "@common/Tab";
import CircularLoader from "@common/CircularLoader";
import Button from "@common/Button";
import "../../webapp/users/dashboard/js/teacherCompetitions.js";
import axios from "@common/axios";
import PagedList from "@common/PagedList";
import {UserContext} from "@context/UserContext";
import {DatePicker, Form, Input, Radio, Select} from "antd";
import GenericDialog from "@common/GenericDialog";
import dayjs from "dayjs";
import SyllabusTopicConceptSelect from "@common/SyllabusTopicConceptSelect";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import {isCancel} from "axios";
import {CheckCircle, Pending} from "@mui/icons-material";
import TableAntD from "@common/TableAntD";
import PopConfirm from "@common/PopConfirm";
import {BrandContext} from "@context/BrandContext";
import TableFilterControls from "@common/TableFilterControls";
import TableFilterControlsForm from "@common/TableFilterControlsForm";
import TableFilterControlsSection from "@common/TableFilterControlsSection";

const Competitions = props => {
    const TABS = {
        CURRENT: {val: 'CURRENT', assignmentState: 'OPEN', hash: 'current'},
        CLOSED: {val: 'CLOSED', assignmentState: 'CLOSED', hash: 'closed'},
    }
    const RECIPIENT_GROUP = {
        SCHOOLWIDE: {label: 'School wide', value: 'SCHOOLWIDE'},
        CLASSES: {label: 'Classes', value: 'CLASSES'},
        STUDENTS: {label: 'Students', value: 'STUDENTS'}
    }
    const [activeTabKey, setActiveTabKey] = useState(TABS.CURRENT.val);
    const defaultSearchParams = {
        searchRecipient: 'myClasses',
        searchName: ''
    }
    const dialogMinWidth = 800;
    const [searchParams, setSearchParams] = useState(defaultSearchParams);
    const [newCompetition, setNewCompetition] = useState({});
    const [viewCompetition, setViewCompetition] = useState({});
    const [closeAllCompetitions, setCloseAllCompetitions] = useState(false);
    const [archiveAllCompetitions, setArchiveAllCompetitions] = useState(false);
    const [viewCompetitionRecipients, setViewCompetitionRecipients] = useState({});
    const [columnData, setColumnData] = useState([]);
    const [reload, setReload] = useState(null);
    const [availableClasses, setAvailableClasses] = useState([]);

    const [newCompetitionForm] = Form.useForm();
    const [closeAllForm] = Form.useForm();
    const [archiveAllForm] = Form.useForm();
    const [viewRecipientsForm] = Form.useForm();
    const {user} = useContext(UserContext);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const brandConfig = useContext(BrandContext);

    const updateColumnData = () => {
        let columns = [];
        columns.push({title: 'Name/' + brandConfig.conceptName, dataIndex: 'name', key: 'name'});
        columns.push({
            title: (user.subscriberType == 'STUDENT' ? 'Teacher' : 'Owner'),
            dataIndex: 'owner',
            key: 'owner'
        });
        if (user.subscriberType !== 'STUDENT') columns.push({title: 'Created', dataIndex: 'created', key: 'created'});
        columns.push({title: 'Start', dataIndex: 'start', key: 'start'});
        columns.push({title: 'End', dataIndex: 'end', key: 'end'});
        if (user.subscriberType !== 'STUDENT') columns.push({
            title: 'Recipients/Results',
            dataIndex: 'results',
            key: 'results'
        });
        if (user.subscriberType == 'STUDENT' && activeTabKey == TABS.CLOSED.val) columns.push({
            title: 'Closed',
            dataIndex: 'closed',
            key: 'closed'
        });
        if (user.subscriberType == 'STUDENT') columns.push({title: 'Notes', dataIndex: 'notes', key: 'notes'});
        columns.push({
            title: (user.subscriberType == 'STUDENT' ? 'Action' : 'Leaderboard'),
            dataIndex: 'action',
            key: 'action'
        });
        if (user.subscriberType !== 'STUDENT') columns.push({
            title: (activeTabKey == TABS.CURRENT.val ?
                <Button onClick={handleCloseAllCompetitions} aria-label={'Close All ' + brandConfig.competitionsName}>Close All</Button> :
                <Button onClick={handleArchiveAllCompetitions} aria-label={'Archive All ' + brandConfig.competitionsName}>Archive All</Button>), dataIndex: 'close', key: 'close'
        });
        setColumnData(columns);
    }

    const searchCompetitions = (params, handleTableData, handlePagingData, abortController) => {
        const url = '/web/ui/competition/' + (user.subscriberType == 'STUDENT' ? 'student' : 'teacher') + '/view';
        axios.get(url, {params: params, signal: abortController.signal})
            .then(response => {
                if (response && response.data) {
                    let dataSource = [];
                    response.data.competitions.map((competition, index) => {
                        const row = {
                            key: index,
                            name: <div><p>{competition.competitionName}</p><p>{competition.conceptName}</p></div>,
                            owner: competition.teacherName
                        };
                        if (user.subscriberType !== 'STUDENT') row.created = user.dateTimeFormat.format(competition.createdDate);
                        row.start = user.dateTimeFormat.format(competition.startDate);
                        row.end = competition.endDate ? user.dateTimeFormat.format(competition.endDate) : 'N/A';
                        if (user.subscriberType !== 'STUDENT') {
                            row.results = <>
                                <Button type={'text'}
                                        onClick={() => handleShowRecipientGroup(competition.competitionId)}>
                                    {competition.competitionRecipientGroup == RECIPIENT_GROUP.SCHOOLWIDE.value ?
                                        competition.schoolName :
                                        competition.competitionRecipientGroup == RECIPIENT_GROUP.CLASSES.value ?
                                            competition.classIds.length + ' class' + (competition.classIds.length > 1 ? 'es' : '') :
                                            competition.studentsTotal + ' student' + (competition.studentsTotal > 1 ? 's' : '')}
                                </Button>
                                <span className={'padding-l--m'}>{competition.studentsTotal}/{competition.completedStudentIds.length} students</span>
                            </>;
                        }
                        if (user.subscriberType == 'STUDENT' && params.assignmentState == TABS.CLOSED.assignmentState) row.closed = user.dateTimeFormat.format(competition.closeDate);
                        if (user.subscriberType == 'STUDENT') row.notes = competition.message;
                        if (user.subscriberType == 'STUDENT' && params.assignmentState == TABS.CURRENT.assignmentState)
                            row.action = <Button onClick={handleStartCompetition} data-comp-id={competition.competitionId}
                                                 disabled={!competition.startAble} aria-label={'Start ' + brandConfig.competitionName.toLowerCase() + ' ' + competition.competitionName}>Start</Button>;
                        else row.action = <Button onClick={handleViewCompetition} aria-label={(user.subscriberType !== 'STUDENT' ? 'View ' : 'Leaderboard for ') + brandConfig.competitionName.toLowerCase() + ' ' + competition.competitionName}
                                                  data-comp-id={competition.competitionId}>{user.subscriberType !== 'STUDENT' ? 'View' : 'Leaderboard'}</Button>;
                        if (user.subscriberType !== 'STUDENT') row.close = (params.assignmentState == TABS.CURRENT.assignmentState ?
                            <PopConfirm title={'Close ' + brandConfig.competitionName + '?'} description={'Are you sure you want to close this ' + brandConfig.competitionName.toLowerCase() + '?'} placement={'left'}
                                               okText={'Close'} onConfirm={async () => await handleCloseCompetition(competition.competitionId)}>
                                <Button disabled={user.userId !== competition.teacherId}
                                        aria-label={'Close ' + brandConfig.competitionName.toLowerCase() + ' ' + competition.competitionName}>Close</Button>
                            </PopConfirm> :
                            <PopConfirm title={'Archive ' + brandConfig.competitionName + '?'} description={'Are you sure you want to archive this ' + brandConfig.competitionName.toLowerCase() + '?'} placement={'left'}
                                               okText={'Archive'} onConfirm={async () => await handleArchiveCompetition(competition.competitionId)}>
                                <Button disabled={user.userId !== competition.teacherId}
                                        aria-label={'Archive ' + brandConfig.competitionName.toLowerCase() + ' ' + competition.competitionName}>Archive</Button>
                            </PopConfirm>);
                        dataSource.push(row);
                    });
                    handleTableData(dataSource);
                    handlePagingData({
                        pageSize: params.pageSize,
                        totalResults: response.data.competitionsTotal ? response.data.competitionsTotal : response.data.competitions.length,
                        currPage: params.pageNumber
                    });
                }
            })
            .catch((error)=>{
                if(!isCancel(error)){
                    console.error('Error retrieving ' + brandConfig.competitionName + ' data: ',error);
                    displayToastMessage('Error retrieving ' + brandConfig.competitionName + ' data:', error, 'error');
                }
            })
            .finally(() => {
                setCloseAllCompetitions(false);
                setArchiveAllCompetitions(false);
                abortController = null;
            });
    }

    const handleTabChange = activeKey => {
        setActiveTabKey(activeKey);
    }

    const handleCreateCompetition = () => {
        setNewCompetition({
            loading: false,
            competitionName: '',
            multipleAttempts: false,
            openDialogDate: dayjs(new Date().getTime()),
            startDate: dayjs(new Date().getTime()),
            endDate: null,
            competitionRecipientGroup: RECIPIENT_GROUP.CLASSES.value,
            classIds: [],
            students: [],
            studentIds: [],
            message: ''
        });
    }

    const handleChangeSearchRecipients = recipients => {
        setSearchParams({...searchParams, searchRecipient: recipients});
    }

    const handleChangeSearchName = name => {
        setSearchParams({...searchParams, searchName: name});
    }

    const handleViewCompetition = event => {
        const competitionId = event.target.dataset.compId;
        axios.get('/web/ui/competition/leaderboard/' + competitionId)
            .then(response => {
                if (response.data.success) {
                    setViewCompetition({
                        ...response.data.competition,
                        userResult: response.data.userResult,
                        studentSearch: {
                            name: '',
                            classId: (response.data.competition.classes.length > 0 ? response.data.competition.classes[0].classId : null),
                            filteredStudents: []
                        },
                        tab: (response.data.competition.competitionRecipientGroup == RECIPIENT_GROUP.SCHOOLWIDE.value ? RECIPIENT_GROUP.CLASSES.value : null)
                    });
                }
            });
    }

    const handleStartCompetition = event => {
        const competitionId = event.target.dataset.compId;
        if (competitionId) {
            loadShortcutByUrl('/competition/loadStudentCompetition.action', {competitionId: competitionId});
        }
    }

    const handleShowRecipientGroup = competitionId => {
        axios.get('/web/ui/competition/viewRecipientClasses', {params: {competitionId: competitionId}})
            .then(response => {
                if (response.data.success) {
                    setViewCompetitionRecipients({
                        competitionId: competitionId,
                        classes: response.data.classes
                    });
                }
            })
    }

    const handleCloseCompetition = async (competitionId) => {
        if (competitionId == null) {
            displayToastMessage('Error', 'Error closing ' + brandConfig.competitionName, 'error', undefined, 10000);
            await new Promise.resolve();
        }

        await axios.post('/web/ui/competition/close', {competitionId: competitionId})
            .then(response => {
                if (response.data.success) {
                    updateReload();
                } else {
                    displayToastMessage('Error', response.data.message, 'error', undefined, 10000);
                }
            });
    }

    const handleCloseAllCompetitions = event => {
        setCloseAllCompetitions(true);
    }

    const handleArchiveCompetition = async (competitionId) => {
        if (competitionId == null) {
            displayToastMessage('Error', 'Error archiving ' + brandConfig.competitionName, 'error', undefined, 10000);
            await new Promise.resolve();
        }

        await axios.post('/web/ui/competition/archive', {competitionId: competitionId})
            .then(response => {
                if (response.data.success) {
                    updateReload();
                } else {
                    displayToastMessage('Error', response.data.message, 'error', undefined, 10000);
                }
            });
    }

    const handleArchiveAllCompetitions = event => {
        setArchiveAllCompetitions(true);
    }

    const loadClassLeaderboard = classId => {
        axios.get('/web/ui/sc/studentsInClass', {params: {classId: classId}})
            .then(response => {
                const studentIds = response.data.map(student => student.userId);
                setViewCompetition({
                    ...viewCompetition,
                    studentSearch: {
                        ...viewCompetition.studentSearch,
                        classId: classId,
                        filteredStudents: viewCompetition.students.filter(student => studentIds.includes(student.userId))
                    }
                });
            });
    }

    const loadStudentsLeaderboard = nameValue => {
        const filteredStudents = viewCompetition.students.filter(student => student.fullName.trim().toLowerCase().indexOf(nameValue.trim().toLowerCase()) !== -1);
        setViewCompetition({
            ...viewCompetition,
            studentSearch: {
                ...viewCompetition.studentSearch,
                name: nameValue,
                filteredStudents: filteredStudents
            }
        });
    }

    const loadCompetitionRecipients = (competitionId, classId) => {
        axios.get('/web/ui/competition/viewRecipients', {params: {competitionId: competitionId, classId: classId}})
            .then(response => {
                if (response.data.success) {
                    setViewCompetitionRecipients({
                        ...viewCompetitionRecipients,
                        classId: classId,
                        competition: response.data.competition
                    })
                }
            })
    }

    const updateReload = () => {
        setReload(new Date().getTime());
    }

    useEffect(() => {
        if (user) setAvailableClasses(user.classes.filter(clazz => clazz.totalStudents));
    }, [user.classes]);

    useEffect(() => {
        if (user) updateColumnData();
    }, [activeTabKey]);

    useEffect(() => {
        if (Object.keys(newCompetition).length !== 0) newCompetitionForm.setFieldsValue(newCompetition);
    }, [newCompetition]);

    useEffect(() => {
        if (viewCompetition.tab) {
            if (viewCompetition.tab == RECIPIENT_GROUP.CLASSES.value) {
                loadClassLeaderboard(viewCompetition.studentSearch.classId);
            } else if (viewCompetition.tab == RECIPIENT_GROUP.STUDENTS.value) {
                loadStudentsLeaderboard(viewCompetition.studentSearch.name);
            }
        } else {
            if (viewCompetition.competitionRecipientGroup == RECIPIENT_GROUP.CLASSES.value) {
                loadClassLeaderboard(viewCompetition.studentSearch.classId);
            } else if (viewCompetition.competitionRecipientGroup == RECIPIENT_GROUP.STUDENTS.value) {
                loadStudentsLeaderboard(viewCompetition.studentSearch.name);
            }
        }
    }, [viewCompetition.tab, viewCompetition.competitionRecipientGroup]);

    useEffect(() => {
        if (viewCompetitionRecipients.competitionId) {
            const classId = viewCompetitionRecipients.classes && viewCompetitionRecipients.classes.length > 0 ? viewCompetitionRecipients.classes[0].classId : null;
            loadCompetitionRecipients(viewCompetitionRecipients.competitionId, classId);
            viewRecipientsForm.setFieldsValue({classId: classId});
        }
    }, [viewCompetitionRecipients.competitionId]);

    const TeacherComponent = () => {
        if (user.subscriberType !== 'STUDENT') {
            return (
                <div className={'padding-y--s'}>
                    <TableFilterControls
                        filterContent={
                            <TableFilterControlsForm
                                  initialValues={{
                                      searchClass: searchParams.searchRecipient,
                                      searchName: searchParams.searchName,
                                  }}
                            >
                                <TableFilterControlsSection showDivider={false}>
                                    {availableClasses.length > 0 &&
                                        <Form.Item label="Class" name="searchClass">
                                            <Select
                                                    onChange={handleChangeSearchRecipients}
                                                    virtual={false} showSearch={false} options={[
                                                {value: 'schoolWide', label: 'School wide'},
                                                {value: 'myClasses', label: 'My classes'},
                                                ...availableClasses.map((clazz) => ({
                                                    value: clazz.classId,
                                                    label: clazz.className,
                                                })),
                                            ]}/>
                                        </Form.Item>
                                    }
                                    <Form.Item label={brandConfig.competitionName + ' name'} name="searchName">
                                        <Input.Search placeholder={'Search by ' + brandConfig.competitionName.toLowerCase() + ' name'} onSearch={handleChangeSearchName}
                                                      enterButton="Search"/>
                                    </Form.Item>
                                </TableFilterControlsSection>
                            </TableFilterControlsForm>
                        }
                    >
                    </TableFilterControls>
                    <Button onClick={handleCreateCompetition} aria-label={'Create New ' + brandConfig.competitionName}>Create</Button>
                </div>
            )
        }

        return null;
    }

    return (
        <>
            <Tabs onChange={handleTabChange} activeKey={activeTabKey} variant={"standard"} destroyOnHidden={true}>
                <Tab tab={<>
                    <Pending className={'margin-r--m'}/>
                    <span className={'margin-r--m tabText'}>{user.subscriberType == 'STUDENT' ? 'In progress' : 'Current'}</span>
                </>} key={TABS.CURRENT.val} hash={TABS.CURRENT.hash}
                     children={<>
                         <TeacherComponent />
                         <TableAntD
                             reload={reload}
                             pagingDependencies={[searchParams]}
                             pagingData={{ fetchFunction: searchCompetitions, params: {assignmentState: 'OPEN', pageSize: 10, currentPage: 1, ...searchParams}}}
                             columnData={columnData}
                             noDataMessage={'No competitions found'}
                             dynamicWidth={true}
                         />
                     </>}
                />
                <Tab tab={<>
                    <CheckCircle className={'margin-r--m'}/>
                    <span className={'margin-r--m tabText'}>{user.subscriberType == 'STUDENT' ? 'Closed / Completed' : 'Completed'}</span>
                </>} key={TABS.CLOSED.val} hash={TABS.CLOSED.hash}
                     children={<>
                         <TeacherComponent />
                         <TableAntD
                             reload={reload}
                             pagingDependencies={[searchParams]}
                             pagingData={{fetchFunction: searchCompetitions, params: {assignmentState: 'CLOSED', pageSize: 10, currentPage: 1, ...searchParams}}}
                             columnData={columnData}
                             noDataMessage={'No competitions found'}
                             dynamicWidth={true}
                         />
                     </>}
                />
            </Tabs>
            {user.subscriberType !== 'STUDENT' &&
                <>
                    <GenericDialog
                        title={'Create ' + brandConfig.competitionName}
                        contentStyle={{minWidth: dialogMinWidth}}
                        open={Object.keys(newCompetition).length !== 0}
                        onClose={() => {setNewCompetition({})}}
                        buttons={[
                            {name: 'Cancel', extraProps: {type: 'text'}},
                            {name: 'Assign', extraProps: {loading: newCompetition ? newCompetition.loading : false}, callback: async () => {
                                    setNewCompetition({...newCompetition, loading: true});
                                    newCompetitionForm.validateFields()
                                        .then(() => {
                                            const formValues = newCompetitionForm.getFieldsValue();
                                            formValues.competitionType = "SCORCHER";
                                            delete formValues.syllabusGroupId;
                                            delete formValues.syllabusId;
                                            axios.post('/web/ui/competition/createNew', formValues,{headers: {'Content-Type': 'application/json'}})
                                                .then(response => {
                                                    setNewCompetition({...newCompetition, loading: false});
                                                    if (response.data.success) {
                                                        setNewCompetition({});
                                                        updateReload();
                                                        displayToastMessage(brandConfig.competitionName + ' successfully assigned', 'View the results and leaderboard from either open or closed competitions.', 'success',null, 5000);
                                                    } else {
                                                        displayToastMessage('Error', 'Error assigning ' + brandConfig.competitionName, 'error', undefined, 10000);
                                                    }
                                                });
                                        }).catch(() => {
                                        setNewCompetition({...newCompetition, loading: false});
                                    });
                                }}
                        ]}>
                        <Form
                            form={newCompetitionForm}
                            className='flexColumn largeGap'
                            style={{display: 'grid', gridTemplateColumns: '49% 49%'}}
                            initialValues={newCompetition}>
                            <div className='flexColumn largeGap'>
                                <Form.Item
                                    label="Name"
                                    name="competitionName"
                                >
                                    <Input maxLength={200} onChange={event => setNewCompetition({...newCompetition, competitionName: event.target.value})} />
                                </Form.Item>
                                <SyllabusTopicConceptSelect
                                    form={newCompetitionForm}
                                    selectLevel='concept'
                                    customTopicsConceptsUrl='/web/ui/competition/getScorcherTopics'
                                />
                                <Form.Item
                                    label={"Format"}
                                    name={"multipleAttempts"}
                                >
                                    <Radio.Group
                                        optionType="button"
                                        options={[
                                            {
                                                label: "One sitting",
                                                value: false
                                            },
                                            {
                                                label: "Multiple sittings",
                                                value: true
                                            }]
                                        }
                                        onChange={event => setNewCompetition({...newCompetition, multipleAttempts: event.target.value})}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={"Start date"}
                                    name={"startDate"}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select a start date.',
                                        }, {
                                            validator: (_, value) => {
                                                if (newCompetition.openDialogDate && value && value < newCompetition.openDialogDate) {
                                                    return Promise.reject('Start date must not be before (' + user.dateTimeFormat.format(newCompetition.openDialogDate) + ').');
                                                }
                                                return Promise.resolve();
                                            },
                                        },
                                    ]}>
                                    <DatePicker
                                        showTime={{
                                            format: 'HH:mm'
                                        }}
                                        format={user.getDateTimeFormatString()}
                                        placement="topLeft"
                                        style={{width: '100%'}}
                                        onChange={date => setNewCompetition({ ...newCompetition, startDate: date })}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label={"End date"}
                                    name={"endDate"}
                                    rules={[
                                        {
                                            validator: (_, value) => {
                                                const currentDate = dayjs(new Date().getTime()).add(1, 'hour').toDate();
                                                if (newCompetition.startDate && value && value < newCompetition.startDate) {
                                                    return Promise.reject('End date must be after start date.');
                                                } else if (value && value < currentDate) {
                                                    return Promise.reject('End date must be in more than 1 hour from now.');
                                                }
                                                return Promise.resolve();
                                            }
                                        }
                                    ]}>
                                    <DatePicker
                                        showTime={{
                                            format: 'HH:mm'
                                        }}
                                        format={user.getDateTimeFormatString()}
                                        placement="topLeft"
                                        style={{width: '100%'}}
                                        onChange={date => setNewCompetition({ ...newCompetition, endDate: date })}
                                    />
                                </Form.Item>
                            </div>
                            <div className='flexColumn largeGap'>
                                <Form.Item
                                    label={"Recipient"}
                                    name={"competitionRecipientGroup"}
                                >
                                    <Radio.Group
                                        optionType="button"
                                        onChange={recipient => {
                                            setNewCompetition({...newCompetition, competitionRecipientGroup: recipient.target.value, classIds: [], students: [], studentIds: []});
                                        }}
                                        options={[
                                            {label: RECIPIENT_GROUP.CLASSES.label, value: RECIPIENT_GROUP.CLASSES.value},
                                            {label: RECIPIENT_GROUP.STUDENTS.label, value: RECIPIENT_GROUP.STUDENTS.value},
                                            {label: RECIPIENT_GROUP.SCHOOLWIDE.label, value: RECIPIENT_GROUP.SCHOOLWIDE.value, style: {whiteSpace: 'nowrap'}}
                                        ]}
                                    />
                                </Form.Item>
                                {newCompetition && newCompetition.competitionRecipientGroup == RECIPIENT_GROUP.CLASSES.value && (
                                    <Form.Item
                                        label="Classes"
                                        name="classIds"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Select at least one class.',
                                            },
                                            {
                                                message: 'Maximum 5 classes.',
                                                validator: (_, classIds) => {
                                                    if (classIds && classIds.length > 0 && classIds.length > 5) {
                                                        return Promise.reject('You can only assign a maximum of 5 classes.');
                                                    } else {
                                                        return Promise.resolve();
                                                    }
                                                }
                                            }
                                        ]}>
                                        <Select
                                            mode="multiple"
                                            maxCount={5}
                                            onChange={classIds => setNewCompetition({...newCompetition, classIds: classIds})}
                                            virtual={false}
                                            showSearch={false}
                                            options={availableClasses.map((clazz) => ({
                                                value: clazz.classId,
                                                label: clazz.className,
                                            }))}
                                        />
                                    </Form.Item>
                                )}
                                {newCompetition && newCompetition.competitionRecipientGroup == RECIPIENT_GROUP.STUDENTS.value && (
                                    <>
                                        <Form.Item
                                            label="Class"
                                            name="classIds"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Select a class.',
                                                }
                                            ]}>
                                            <Select
                                                onChange={classId => {
                                                    axios.get('/web/ui/sc/studentsInClass', {params: {classId: classId}})
                                                        .then(response => {
                                                            if (response.data) {
                                                                let students = [];
                                                                let studentIds = [];
                                                                response.data.map(student => {
                                                                    students.push({
                                                                        id: student.userId,
                                                                        name: student.fullName
                                                                    })
                                                                    studentIds.push(student.userId);
                                                                });
                                                                setNewCompetition({...newCompetition, classIds: [classId], students: students, studentIds: studentIds});
                                                            }
                                                        });
                                                }}
                                                virtual={false}
                                                showSearch={false}
                                                options={availableClasses.map((clazz) => ({
                                                    value: clazz.classId,
                                                    label: clazz.className,
                                                }))}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Students"
                                            name="studentIds"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Select at least one student.',
                                                }
                                            ]}>
                                            <Select
                                                virtual={false}
                                                showarrow={"true"}
                                                mode="multiple"
                                                maxTagCount="responsive"
                                                options={newCompetition.students.map((student) => ({
                                                    value: student.id,
                                                    label: student.name,
                                                }))}
                                            />
                                        </Form.Item>
                                    </>
                                )}
                                <Form.Item
                                    label="Message for students"
                                    name="message"
                                >
                                    <Input.TextArea
                                        count={{
                                            show: true,
                                            max: 230,
                                            exceedFormatter: (txt, {max}) => txt.length > max ? txt.slice(0, max) : txt
                                        }}
                                        onChange={event => setNewCompetition({...newCompetition, message: event.target.value})}
                                    />
                                </Form.Item>
                            </div>
                        </Form>
                    </GenericDialog>
                    <GenericDialog
                        title="Close all competitions"
                        open={closeAllCompetitions}
                        onClose={() => {
                            setCloseAllCompetitions(false);
                            closeAllForm.resetFields();
                        }}
                        buttons={[
                            {name: 'Cancel', extraProps: {type: 'text'}},
                            {name: 'Close all', callback: async () => {
                                    const formValues = {
                                        ...closeAllForm.getFieldsValue(),
                                        ...searchParams
                                    }
                                    axios.post('/web/ui/competition/closeAll', formValues)
                                        .then(response => {
                                            if (response.data.success) {
                                                updateReload();
                                            } else {
                                                displayToastMessage('Error', response.data.message, 'error', undefined, 10000);
                                            }
                                        });
                                }}
                        ]}>
                        <Form form={closeAllForm}
                              className='flexColumn largeGap'
                              initialValues={{
                                  closedDate: dayjs(new Date().getTime())
                              }}>
                            <p>Close all competitions from before:</p>
                            <Form.Item name='closedDate'>
                                <DatePicker
                                    format={user.getDateFormatString()}
                                    placement="topLeft"
                                    style={{width: '100%'}}
                                />
                            </Form.Item>
                        </Form>
                    </GenericDialog>
                    <GenericDialog
                        title="Archive all competitions"
                        open={archiveAllCompetitions}
                        onClose={() => {
                            setArchiveAllCompetitions(false);
                            archiveAllForm.resetFields();
                        }}
                        buttons={[
                            {name: 'Cancel', extraProps: {type: 'text'}},
                            {name: 'Archive all', callback: async () => {
                                    const formValues = {
                                        ...archiveAllForm.getFieldsValue(),
                                        ...searchParams
                                    }
                                    axios.post('/web/ui/competition/archiveAll', formValues)
                                        .then(response => {
                                            if (response.data.success) {
                                                updateReload();
                                            } else {
                                                displayToastMessage('Error', response.data.message, 'error', undefined, 10000);
                                            }
                                        });
                                }}
                        ]}>
                        <Form form={archiveAllForm}
                              className='flexColumn largeGap'
                              initialValues={{
                                  archivedDate: dayjs(new Date().getTime())
                              }}>
                            <p>Archive all competitions from before:</p>
                            <Form.Item name='archivedDate'>
                                <DatePicker
                                    format={user.getDateFormatString()}
                                    placement="topLeft"
                                    style={{width: '100%'}}
                                />
                            </Form.Item>
                        </Form>
                    </GenericDialog>
                    <GenericDialog
                        title={brandConfig.competitionName + ' recipients'}
                        contentStyle={{minWidth: dialogMinWidth}}
                        open={Object.keys(viewCompetitionRecipients).length !== 0}
                        onClose={() => {
                            setViewCompetitionRecipients({});
                            viewRecipientsForm.resetFields();
                        }}
                        buttons={[{name: 'Close'}]}>
                        <Form
                            form={viewRecipientsForm}
                            className='flexColumn largeGap'
                            initialValues={viewCompetitionRecipients}
                        >
                            {viewCompetitionRecipients && viewCompetitionRecipients.classes && viewCompetitionRecipients.classes.length > 1 && (
                                <Form.Item
                                    label="Classes"
                                    name="classId"
                                >
                                    <Select className="flex" style={{width: '200px'}}
                                            virtual={false}
                                            showarrow={"true"}
                                            onChange={classId => loadCompetitionRecipients(viewCompetitionRecipients.competitionId, classId)}
                                            options={viewCompetitionRecipients.classes.map((clazz) => ({
                                                value: clazz.classId,
                                                label: clazz.className,
                                            }))}
                                    />
                                </Form.Item>
                            )}
                            {viewCompetitionRecipients && viewCompetitionRecipients.classes && viewCompetitionRecipients.classes.length == 1 && (
                                <div className={'padding-l--m'}>Class: {viewCompetitionRecipients.classes[0].className}</div>
                            )}
                            {viewCompetitionRecipients && viewCompetitionRecipients.competition ? (
                                <PagedList
                                    columns={[
                                        {title: 'Student', dataIndex: 'student', key: 'student'},
                                        {title: 'Status', dataIndex: 'status', key: 'status'},
                                        {title: 'Updated', dataIndex: 'updated', key: 'updated'},
                                        {title: 'Score', dataIndex: 'score', key: 'score'},
                                        {title: 'Time', dataIndex: 'time', key: 'time'},
                                    ]}
                                    dataSource={
                                        viewCompetitionRecipients.competition.competitionStudents.map(student => {
                                            let row = {
                                                key: student.userId,
                                                student: student.fullName,
                                                status: student.competitionUserState,
                                                updated: user.dateFormat.format(student.updatedDate)
                                            }
                                            row.score = (student.competitionUserState == 'COMPLETED' ? student.bestCompetitionUserResult.mark + "/" + student.bestCompetitionUserResult.maxMark : 'N/A');
                                            row.time = (student.competitionUserState == 'COMPLETED' ? student.bestCompetitionUserResult.formattedTime : 'N/A');
                                            return row;
                                        })
                                    }
                                    size={"small"}
                                />
                            ) : (
                                <CircularLoader />
                            )}
                        </Form>
                    </GenericDialog>
                </>
            }
            <GenericDialog
                title={brandConfig.competitionName + ' leaderboard'}
                contentStyle={{minWidth: dialogMinWidth}}
                open={Object.keys(viewCompetition).length !== 0}
                onClose={() => {setViewCompetition({})}}
                buttons={[{name: 'Close'}]}>
                <Form
                    className='flexColumn largeGap'
                    initialValues={viewCompetition}>
                    {viewCompetition.tab != null && (
                        <Form.Item
                            label="Search by"
                            name="tab"
                        >
                            <Radio.Group
                                optionType="button"
                                onChange={recipient => setViewCompetition({...viewCompetition, tab: recipient.target.value})}
                                options={[
                                    {label: RECIPIENT_GROUP.CLASSES.label, value: RECIPIENT_GROUP.CLASSES.value},
                                    {label: RECIPIENT_GROUP.STUDENTS.label, value: RECIPIENT_GROUP.STUDENTS.value},
                                ]}
                            />
                        </Form.Item>
                    )}
                    {(viewCompetition.competitionRecipientGroup == RECIPIENT_GROUP.CLASSES.value ||
                        (viewCompetition.tab != null && viewCompetition.tab == RECIPIENT_GROUP.CLASSES.value)) && (
                        <Form.Item
                            label="Class"
                            name={['studentSearch', 'classId']}>
                            <Select
                                virtual={false}
                                showarrow={"true"}
                                onChange={classId => loadClassLeaderboard(classId)}
                                options={viewCompetition.classes.map((clazz) => ({
                                    value: clazz.classId,
                                    label: clazz.className,
                                }))}
                            />
                        </Form.Item>
                    )}
                    {(viewCompetition.competitionRecipientGroup == RECIPIENT_GROUP.STUDENTS.value ||
                        (viewCompetition.tab != null && viewCompetition.tab == RECIPIENT_GROUP.STUDENTS.value)) && (
                        <Form.Item label="Students"
                                   name={['studentSearch', 'name']}>
                            <Input.Search className="flex" placeholder="Search by name" onSearch={loadStudentsLeaderboard} enterButton="Search" />
                        </Form.Item>
                    )}
                    {viewCompetition.userResult && viewCompetition.userResult.bestCompetitionUserResult && (
                        <p>
                            <span className="ch-text-b">Your best result:</span> Rank {viewCompetition.userResult.rank}, with a score of {viewCompetition.userResult.bestCompetitionUserResult.mark}/{viewCompetition.userResult.bestCompetitionUserResult.maxMark} and a time of {viewCompetition.userResult.bestCompetitionUserResult.formattedTime}.
                        </p>
                    )}
                    {viewCompetition.students ? (
                        <PagedList
                            columns={[
                                {title: 'Rank', dataIndex: 'rank', key: 'rank'},
                                {title: 'Student', dataIndex: 'student', key: 'student'},
                                {title: 'Score', dataIndex: 'score', key: 'score'},
                                {title: 'Time', dataIndex: 'time', key: 'time'},
                            ]}
                            dataSource={((viewCompetition.competitionRecipientGroup == RECIPIENT_GROUP.CLASSES.value ||
                                (viewCompetition.tab && viewCompetition.tab == RECIPIENT_GROUP.CLASSES.value)) ||
                            (viewCompetition.studentSearch.name !== '')
                                ? viewCompetition.studentSearch.filteredStudents
                                : viewCompetition.students).map((student, index) => {
                                return {
                                    key: student.userId,
                                    rank: <div className={'ch-competition-rank ' + ((student.rank == 1 ? 'ch-gold' : student.rank == 2 ? 'ch-silver' : student.rank == 3 ? 'ch-bronze' : ''))}>{student.rank > 3 && student.rank}</div>,
                                    student: student.fullName,
                                    score: student.bestCompetitionUserResult.mark + "/" + student.bestCompetitionUserResult.maxMark,
                                    time: student.bestCompetitionUserResult.formattedTime
                                }
                            })}
                            rowClassName={(record) => {
                                return record.key == user.userId ? 'ch-dataTable-highlight' : '';
                            }}
                            size={"small"}
                        />
                    ) : (
                        <>No results recorded yet.</>
                    )}
                </Form>
            </GenericDialog>
        </>
    );
}

export default Competitions;